import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import { TSupersetDashboard, TSupersetStore } from './types';

export const getSupersetState = (state: TStoreState): TSupersetStore => state.superset;

export const getSupersetDashboards = createSelector(
	[getSupersetState],
	(superset: TSupersetStore): TSupersetDashboard[] | null => superset.dashboards,
);

export const getSupersetDashboardsLoading = createSelector(
	[getSupersetState],
	(superset: TSupersetStore) => superset.dashboardsLoading,
);

export const getSelectedSupersetDashboardId = createSelector(
	[getSupersetState],
	(superset: TSupersetStore): string | null => superset.selectedDashboardId,
);

export const getSelectedSupersetDashboard = createSelector(
	[getSupersetDashboards, getSelectedSupersetDashboardId],
	(dashboards, selectedDashboardId): TSupersetDashboard | null =>
		dashboards?.find((dashboard) => dashboard.id === selectedDashboardId) ?? null,
);
